import { type ComponentType, Suspense } from 'react';
import { getPlatformComponent } from '@direct-frontend/platform-code';
import { ApplicationStub } from '../../application/ApplicationStub';

const ApplicationLayout = getPlatformComponent<ComponentType>({
    desktop: import('./ApplicationLayout@desktop'),
    mobile: import('./ApplicationLayout@mobile'),
});

export function ApplicationLayoutRouteSuspense() {
    return (
        <Suspense fallback={<ApplicationStub />}>
            <ApplicationLayout />
        </Suspense>
    );
}
